module.exports = __webpack_public_path__ + "img/homepage_0--mobile@3x.fc56f202.jpg";